import { render, staticRenderFns } from "./CardPub.vue?vue&type=template&id=19aaff62&scoped=true&"
import script from "./CardPub.vue?vue&type=script&lang=js&"
export * from "./CardPub.vue?vue&type=script&lang=js&"
import style0 from "./CardPub.vue?vue&type=style&index=0&id=19aaff62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aaff62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
